// This icon file is generated automatically.
var ComponentOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 20 20", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M18.62 3.45h-3.45a3.45 3.45 0 00-6.9 0H4.84c-.76 0-1.38.62-1.38 1.38v3.45a3.45 3.45 0 100 6.9v3.44c0 .76.62 1.38 1.38 1.38h4.83v-1.38a2.07 2.07 0 114.13 0V20h4.83c.76 0 1.38-.62 1.38-1.38V13.8h-1.38a2.07 2.07 0 110-4.13H20V4.83c0-.76-.62-1.38-1.38-1.38zm-3.45 8.27c0 1.9 1.55 3.45 3.45 3.45v3.45h-3.45a3.45 3.45 0 10-6.9 0H4.84V13.8H3.45a2.07 2.07 0 110-4.13h1.38V4.83h4.83V3.45a2.07 2.07 0 114.13 0v1.38h4.83v3.45a3.45 3.45 0 00-3.45 3.44z" } }] }, "name": "component", "theme": "outlined" };
export default ComponentOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/ComponentOutlined.js
// module id = 2298
// module chunks = 0